export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return {
    // 用户列表
    userList: function userList(data) {
      return request({
        url: '/auth/users',
        method: 'get',
        data: data
      });
    },
    // 用户详情
    userDetails: function userDetails(data) {
      return request({
        url: '/user/upUser',
        method: 'get',
        data: data
      });
    },
    // 添加用户
    userAddList: function userAddList(data) {
      return request({
        url: '/user/add',
        method: 'get',
        data: data
      });
    },
    // 添加用户
    userAdd: function userAdd(data) {
      return request({
        url: '/user/add',
        method: 'post',
        data: data
      });
    },
    // 修改用户
    userUpd: function userUpd(data) {
      return request({
        url: '/user/upUser',
        method: 'post',
        data: data
      });
    },
    // 修改用户状态
    disableUser: function disableUser(data) {
      return request({
        url: '/user/disableUser',
        method: 'get',
        data: data
      });
    },
    // 删除用户
    delUser: function delUser(data) {
      return request({
        url: '/user/delUser',
        method: 'get',
        data: data
      });
    },
    // 获取用户的应用权限
    userAppRole: function userAppRole(data) {
      return request({
        url: '/user/userAppRole',
        method: 'get',
        data: data
      });
    },
    // 用户应用权限修改
    userAppRoleUpd: function userAppRoleUpd(data) {
      return request({
        url: '/user/userAppRoleUpd',
        method: 'post',
        data: data
      });
    },
    // 获取用户操作日志
    userOperationLog: function userOperationLog(data) {
      return request({
        url: '/user/operation_log',
        method: 'get',
        data: data
      });
    },
    //获取时间接口
    userOperationLogData: function userOperationLogData(data) {
      return request({
        url: '/user/operation_log_data',
        method: 'get',
        data: data
      });
    },
    enterpriseList: function enterpriseList(data) {
      return request({
        url: '/enterpriseList',
        method: 'get',
        data: data
      });
    },
    enterpriseAdd: function enterpriseAdd(data) {
      return request({
        url: '/enterprise/add',
        method: 'post',
        data: data
      });
    },
    enterpriseUpdate: function enterpriseUpdate(data) {
      return request({
        url: '/enterprise/update',
        method: 'get',
        data: data
      });
    },
    enterpriseDel: function enterpriseDel(data) {
      return request({
        url: '/enterprise/del',
        method: 'get',
        data: data
      });
    },
    enterpriseAudit: function enterpriseAudit(data) {
      return request({
        url: '/enterprise/audit',
        method: 'get',
        data: data
      });
    },
    enterpriseAppSave: function enterpriseAppSave(data) {
      return request({
        url: '/enterprise/appSave',
        method: 'post',
        data: data
      });
    },
    authAppList: function authAppList(data) {
      return request({
        url: '/enterprise/authAppList',
        method: 'get',
        data: data
      });
    },
    subAdminTree: function subAdminTree(data) {
      return request({
        url: '/subAdminTree',
        method: 'get',
        data: data
      });
    },
    enterpriseByuser: function enterpriseByuser(data) {
      return request({
        url: '/enterpriseByuser',
        method: 'get',
        data: data
      });
    },
    subUserList: function subUserList(data) {
      return request({
        url: '/subUserList',
        method: 'get',
        data: data
      });
    }
  };
});